export const reasonOftenUnread = "hpA7Fb";
export const reasonTooMuchMail = "S8FKne";
export default {reasonOftenUnread,reasonTooMuchMail};